.assignee-button-container {
    width: 220px;
}

.header-action-bar-container {
    /* width of full header minus the width of the lead icon */
    width: calc(100% - 40px);
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.name-container {
    overflow: hidden;
    width: 100%;
    min-width: 200px;
}
